export default __webpack_public_path__ + "static/media/main_slide_Image2.f1c1e90d.jpg";